import {
  FieldValues,
  FormFieldControl,
  FormFieldControlProps,
  WithFieldNameProp,
  useController,
} from '@eigtech/ui-shared-forms/shadcn'
import { LexicalEditor } from 'lexical'
import { ReactNode } from 'react'
import { MentionsInput, MentionsInputProps } from './MentionsInput'

type OmittedProps = Exclude<keyof FormFieldControlProps, 'children'>

type TopLevelMentionsProps<TFieldValues extends FieldValues = FieldValues> = WithFieldNameProp<
  Omit<MentionsInputProps, OmittedProps>,
  TFieldValues
>

export type MentionsInputFieldProps<TFieldValues extends FieldValues = FieldValues> =
  TopLevelMentionsProps<TFieldValues> & {
    className?: string
    label?: ReactNode
    fieldProps?: Omit<FormFieldControlProps, 'label' | 'name'>
    mentionsProps?: Partial<Omit<MentionsInputProps, keyof TopLevelMentionsProps<TFieldValues>>>
  }

export function MentionsInputField<TFieldValues extends FieldValues = FieldValues>({
  ref,
  name,
  label,
  fieldProps,
  mentionsProps,
  children,
  ...props
}: MentionsInputFieldProps<TFieldValues> & { ref?: React.Ref<LexicalEditor> }) {
  const {
    field: { value: defaultValue, onBlur: __onBlur, ...field },
    formState: { isSubmitting },
  } = useController({
    name,
    control: fieldProps?.control,
  })

  return (
    <FormFieldControl className="h-full" {...fieldProps} label={label} name={name}>
      <MentionsInput
        {...field}
        defaultValue={defaultValue}
        editorRef={ref}
        isDisabled={isSubmitting ?? fieldProps?.disabled}
        {...mentionsProps}
        {...(props as MentionsInputProps)}
      >
        {children}
      </MentionsInput>
    </FormFieldControl>
  )
}

export type MentionsInputFieldComponent<TFieldValues extends FieldValues = FieldValues> =
  typeof MentionsInputField<TFieldValues>

// MentionsInputFieldProps<TFieldValues>

// interface ForwardRefWithGenerics extends React.FC<WithForwardRefProps<Option>> {
//   <T extends Option>(props: WithForwardRefProps<T>): ReturnType<
//     React.FC<WithForwardRefProps<T>>
//   >;
// }
